export const API_URL = "https://api.rfap.ir";
export const APP_API_URL = "https://api.sanaap.co";

export const activeTakmiliSignup = false;

